import styled from "styled-components";
import { flex, responsive } from "../../mixins";

export const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: end;
  gap: 1rem;
  ${responsive.tablet.standard`
    display: none;
  `}
`;

export const Container = styled.div`
  ${flex({ flexDirection: "row" })}
  gap: 1rem;
`;
